import { createBrowserRouter, Navigate } from "react-router-dom";
import MainLayout from "./layouts/main-layout";
import LabelPage from "./pages/label-page";
import PhenoPage from "./pages/pheno-page";
import WindPage from "./pages/wind-page";
import ForecastPage from "./pages/forecast-page";
import SkyDataMainLayout from "./layouts/skydata-main-layout";
import SkydataForecastPage from "./pages/skydata/forecast-page";
import SkydataPhenoPage from "./pages/skydata/pheno-page";
import SkydataWindPage from "./pages/skydata/wind-page";

export const router = createBrowserRouter([
  {
    path: "/",
    element:
      "ntv" === "ntv" ? (
        <MainLayout />
      ) : (
        <SkyDataMainLayout />
      ),
    // ✅ element болгож зассан
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />, // ✅ replace нэмэхийг зөвлөж байна
      },
      {
        path: ":type",
        element: <LabelPage />,
      },
      {
        path: "pheno/:type",
        element:
          "ntv" === "ntv" ? (
            <PhenoPage />
          ) : (
            <SkydataPhenoPage />
          ),
      },
      {
        path: "wind/:type",
        element:
          "ntv" === "ntv" ? (
            <WindPage />
          ) : (
            <SkydataWindPage />
          ),
      },
      {
        path: "forecast/:type",
        element:
          "ntv" === "ntv" ? (
            <ForecastPage />
          ) : (
            <SkydataForecastPage />
          ),
      },
    ],
  },
]);
